var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.value.page,"page-sizes":_vm.pageSizes,"page-size":_vm.value.size,"layout":_vm.layout,"total":_vm.value.count},on:{"current-change":_vm.pageChange,"size-change":_vm.sizeChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }